import { Title } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '@environments/environment';

// type Severities = 'success' | 'info' | 'warn' | 'error';

export enum GrowlSeverity {
    success = 'success',
    info = 'info',
    warn = 'warn',
    error = 'error'
}

@Injectable({providedIn: 'root'})
export class GrowlService {
  growlTimeout = environment.growlTimeout;



  notificationChange: Subject<Object> = new Subject<Object>();

  notify(
    severity: GrowlSeverity,
    title: string,
    detail: string,
    lifeTime?: number
  ) {
    if (typeof(lifeTime) === 'undefined') {
      lifeTime = this.growlTimeout;
    }

    this.notificationChange.next({ severity, summary: title, detail, lifeTime });
  }
}
